import axios from "axios";

import { PARTNER_AUTHORIZATION, TOKEN_URL } from "@/utils/apiUrls";
import { createReferenceId } from "@/utils/initializeSentry";

export type PartnerSalesLoginCredentials = {
  email: string;
  password: string;
};

export const partnerSalesLogin = async ({
  email,
  password,
}: PartnerSalesLoginCredentials) => {
  const referenceId = createReferenceId();
  const params = new URLSearchParams({
    grant_type: "pos_login",
    username: email,
    password,
  });

  const response = await axios.post(TOKEN_URL.toString(), params, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: PARTNER_AUTHORIZATION,
      "X-Reference-Id": referenceId,
    },
  });

  if (!response.data.access_token) {
    throw new Error("No access token received");
  }

  return {
    accessToken: response.data.access_token as string,
    refreshToken: (response.data.refresh_token as string | undefined) ?? null,
  };
};
